<template>
    <div class="row">
        <div class="col-4 align-self-center">
            <button @click="back" type="button" class="btn-light-primary text-uppercase me-1 align-middle btn-footer">
                {{ this.trans.get('buttons.back') }}
            </button>
            <button @click="cancel" type="button" class="btn btn-light-primary text-uppercase align-middle btn-footer">
                {{ this.trans.get('buttons.cancel') }}
            </button>
        </div>

        <div class="col-4 align-self-center text-center d-flex align-items-center justify-content-center font-s-12">
            <div class="container">
                <div class="row mb-2">
                    <div class="col-12 align-self-center text-center">
                        <div class="time-left" v-if="this.$root.second_left > 0">{{this.trans.get('kiosk.time-left')}} {{ this.$root.time_converted }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 align-self-center text-center align-items-center" @touchstart="this.start_logo_timer()" @mousedown="this.start_logo_timer()" @touchend="this.stop_timer()" @mouseup="this.stop_timer()">
                        {{ this.trans.get('kiosk.powered-by') }} &nbsp;

                        <object data="/assets/kiosk/img/xpayrience_logo.svg" type="image/svg+xml" alt="xPayrience.com" class="footer_logo_xpay align-middle">
                            <img src="/assets/kiosk/img/xpayrience_logo.svg">
                        </object>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-4 align-self-center text-end">
            <button
                @click="confirm"
                type="submit"
                class="btn btn-primary btn-confirm"
                :disabled="this.$root.disabled_next_btn"
                v-if="this.$root.show_btn_confirmer"
                >
                {{ this.btn_confirm }}


            </button>
        </div>
    </div>
</template>

<script>
import {defineComponent} from "vue";
import {isset} from "../../helpers/kiosk-helpers";

export default defineComponent({
    name: "FooterTickets",
    data() {
        return {
            valid_ticket_done_interval: null,
            btn_confirm: this.trans.get('buttons.confirm'),
            logo_press_time:0,
            logo_timer:null,
        }
    },

    methods: {
        init()
        {
            this.$root.disabled_next_btn = true;

            if(this.section === 'summary')
            {
                this.btn_confirm = this.trans.get('buttons.accept_and_confirm');

                if(this.$root.cart_is_empty === false) {
                    this.$root.disabled_next_btn = false;
                }
            }
        },


        back()
        {
            if(this.section === 'ticketing')
            {
                this.$router.push({ name: this.$root.locale + '.home' });
            }
            else if(this.section === 'seating')
            {

                if(Object.keys(window.seating_chart_info).length !== 0)
                {
                    window.seating_chart_info['seating_chart_app'].Destroy();
                    window.seating_chart_info = {};
                }

                this.$router.push({ name: this.$root.locale + '.tickets' });
            }
            else if(this.section === 'summary')
            {
                if(this.$root.has_seating_chart === true)
                {
                    this.$router.push({ name: this.$root.locale + '.seating' });
                }
                else {
                    this.$router.push({ name: this.$root.locale + '.tickets' });
                }
            }
            else if(this.section === 'payment')
            {
                this.$router.push({ name: this.$root.locale + '.summary' });
            }

        },

        cancel()
        {
            this.$root.cancel();
        },

        confirm()
        {
            if(this.section === 'ticketing')
            {
                this.confirmTickets();
            }
            else if(this.section === 'seating')
            {
                if(Object.keys(window.seating_chart_info).length !== 0)
                {
                    window.seating_chart_info['seating_chart_app'].Destroy();
                    window.seating_chart_info = {};
                }
                this.$router.push({ name: this.$root.locale + '.summary' });
            }
            else if(this.section === 'summary')
            {
                this.$router.push({ name: this.$root.locale + '.payment' });
            }
        },

        confirmTickets()
        {
            this.$root.disabled_next_btn = true;
            this.$root.current_event_is_loaded.push('confirm-ticketing');
            this.$root.current_loading_message = "";



            for (var key in this.$root.ticketing.item) {

                if(!isset(this.$root.cart_products_quantity[key]))
                {
                    if(this.$root.ticketing.item[key].quantity > 0)
                    {
                        this.$root.createCartItem(this.$root.ticketing.item[key]);
                    }
                }
                else
                {
                    let current_item_qty = this.$root.cart_products_quantity[key];

                    if(current_item_qty < this.$root.ticketing.item[key].quantity)
                    {
                        this.$root.ticketing.item[key].quantity = this.$root.ticketing.item[key].quantity - current_item_qty;
                        this.$root.createCartItem(this.$root.ticketing.item[key]);
                    }
                    else if(current_item_qty > this.$root.ticketing.item[key].quantity)
                    {

                        this.$root.ticketing.item[key].quantity = current_item_qty - this.$root.ticketing.item[key].quantity;
                        this.$root.deleteCartItem(this.$root.ticketing.item[key]);
                    }
                }
            }



            this.valid_ticket_done_interval = setInterval(this.checkTicketDone,200);



        },
        checkTicketDone(interval)
        {
            if(this.$root.has_call_ajax.length <= 0)
            {
                clearInterval(this.valid_ticket_done_interval);


                this.$root.refreshCart()
                    .then(cart => {
                        this.$root.current_event_is_loaded = this.$root.arrayRemove(this.$root.current_event_is_loaded,'confirm-ticketing');
                        if(Object.keys(window.seating_chart_info).length !== 0)
                        {
                            window.seating_chart_info['seating_chart_app'].Destroy();
                        }
                        this.$router.push({ name: this.$root.locale + '.seating' });
                    })
                    .catch(error => {
                        this.$root.addErrors('error',null,String(error));
                    });

            }
        },

        start_logo_timer()
        {
            this.logo_timer = setInterval(this.add_logo_timer,1000);
        },
        add_logo_timer()
        {
            this.logo_press_time++;
            let time_to_hold = 1;
            if(this.logo_press_time >= time_to_hold)
            {
                this.$root.admin_show = true;
                this.stop_timer();
            }
        },
        stop_timer()
        {
            clearInterval(this.logo_timer);
            this.logo_press_time = 0;

        },


    },
    created() {
        this.init();
    },

    mounted: function mounted() {
    },

    props: {
        section: String,
    },
})
</script>

<style scoped>

</style>
